import axios from 'axios';
import { getAuthHeaders } from '../utils/authUtils';

const base = () => `${process.env.REACT_APP_API_URL}/api/v3/task-import`;
const config = () => ({ headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' } });

/**
 * SmartSheet CSV import. Both calls take { csv, dateFormat, decisions, grantContentAccess };
 * decisions maps a row's line number to SMARTSHEET, EDITOR or SKIP.
 */
const TaskImportService = {
    dryRun: async (body) => (await axios.post(`${base()}/dry-run`, body, config())).data,
    commit: async (body) => (await axios.post(`${base()}/commit`, body, config())).data,
};

export default TaskImportService;
